import React from 'react';
import SearchBar from '../SearchBar/SearchBar';
import './TeacherDocumentsCard.css';

function TeacherDocumentsCard() {
  return (
    <section className="new-site-documents-card-root" aria-label="Öğretmen döküman kartı">
      <h1 className="new-site-documents-card-title">Öğretmenler için ücretsiz dökümanlar</h1>
      <p className="new-site-documents-card-description">
        Ders planları, etkinlikler, sınavlar, formlar ve daha fazlası. Zaman kazanın, ilham alın,
        paylaşın.
      </p>
      <div className="new-site-documents-card-search-wrap">
        <SearchBar />
      </div>
    </section>
  );
}

export default TeacherDocumentsCard;